import React, { useState } from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import IndividualAccountSections from "./IndividualAccountsTab/IndividualAccountSections";
import NonIndividualAccountSections from "./NonIndividualAccountsTab/NonIndividualAccountSections";
import AccountsOverview from "./OverviewTab/AccountsOverview";
import { useClientContext } from "../../context/ClientContext";

function LeadAllTabs(props) {
    const [activeTab, setActiveTab] = useState("overview");
    const { setSelectedClient, setShouldPrefill } = useClientContext();

    const handleOverviewClick = () => {
        setSelectedClient(null);
        setShouldPrefill(false);
        localStorage.removeItem("IndiMobileNo");
        localStorage.removeItem("noAlreadyRegis");
        localStorage.removeItem("saveRelationVal");
        localStorage.removeItem("IndiEmail");
        localStorage.removeItem("mailAlreadyRegis");
        localStorage.removeItem("SaveRelationEmail");
        document.getElementById("admin-tab")?.click();
      };
    //   console.log(activeTab, "activeTab");
    return (
        <div>
            <Header title={props.title} portal={""} />
            <SingleSignOnSideBar />
            <main id="main-content">
                <div className="tab-content" id="mainTabContent">
                    <div
                        className="tab-pane fade show active"
                        id="team"
                        role="tabpanel"
                        aria-labelledby="team-tab"
                    >
                        <div className="secondary-tabs">
                            <div className="card-tab-list">
                                <ul className="nav page-tabs page-buttons" id="mainTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="tab-button active"
                                            id="admin-tab"
                                            data-toggle="tab"
                                            data-target="#admin"
                                            type="button"
                                            role="tab"
                                            aria-controls="admin"
                                            aria-selected={activeTab === "overview"}
                                            onClick={()=>{
                                                handleOverviewClick();
                                                setActiveTab("overview");
                                            }}

                                        >
                                            Lead Overview
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation"  >
                                        <button
                                            className="tab-button"
                                            id="rejection-tab"
                                            data-toggle="tab"
                                            data-target="#rejection"
                                            type="button"
                                            role="tab"
                                            aria-controls="rejection"
                                            aria-selected={activeTab === "individual"}
                                            onClick={() => {setActiveTab("individual")
                                                setShouldPrefill(true)
                                            }}
                                        >
                                            Individual Account
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className="tab-button"
                                            id="deletedash-tab"
                                            data-toggle="tab"
                                            data-target="#deletedash"
                                            type="button"
                                            role="tab"
                                            aria-controls="deletedash-tab"
                                            aria-selected={activeTab === "non-individual"}
                                            onClick={() => setActiveTab("non-individual")}
                                        >
                                            Non-Individual Account
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <div className="card-tab-details">
                                <div
                                    className="tab-content dashboard-tab-content"
                                    id="nav-tabContent"
                                >
                                    <div
                                        className="tab-pane fade show active"
                                        id="admin"
                                        role="tabpanel"
                                        aria-labelledby="nav-admin-tab"
                                    >
                                        <AccountsOverview activeTab={activeTab} />
                                    </div>
                                    <div
                                        className="tab-pane fade show"
                                        id="rejection"
                                        role="tabpanel"
                                        aria-labelledby="nav-rejection-tab"
                                    >
                                        <IndividualAccountSections activeTab={activeTab}/>
                                    </div>
                                    <div
                                        className="tab-pane fade show "
                                        id="deletedash"
                                        role="tabpanel"
                                        aria-labelledby="nav-deletedash-tab"
                                    >
                                        <NonIndividualAccountSections />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}

export default LeadAllTabs;
